import { render, staticRenderFns } from "./DictionaryEnumEditPage.vue?vue&type=template&id=25c1df4e&scoped=true&"
import script from "./DictionaryEnumEditPage.vue?vue&type=script&lang=js&"
export * from "./DictionaryEnumEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1df4e",
  null
  
)

export default component.exports